import { useMutation } from "react-query";
import { addSingleSafe } from "../../../../actions/CarrierAgreementMgmt/Security";

const useAddSingleCamera = () => {
  return useMutation(addSingleSafe);
};
export default useAddSingleCamera;
